import { render, staticRenderFns } from "./AddEditAddition.vue?vue&type=template&id=06b92b66&"
import script from "./AddEditAddition.vue?vue&type=script&lang=ts&"
export * from "./AddEditAddition.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports